module.exports = __webpack_public_path__ + "static/media/texture.dd2640c4.svg";